export const noConnectionTitle = "pVSrNb";
export const noConnectionMessage = "iqLeHb";
export const closeNetworkButtonArialLabel = "jipsDc";
export default {noConnectionTitle,noConnectionMessage,closeNetworkButtonArialLabel};